import { find, get } from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import css from 'cape-style'
import LinkEl from 'cape-mixer/lib/Link/Link'
// import { getLink } from '../Schedule/ShowGroup'

import { ShowTitle, Description } from './styles'

const getLocName = loc => get(find(loc), 'name')
const getShowId = showGroup => get(find(showGroup), 'id')

function ShowDetails({ location, showGroup }) {
  return (
    <div>
        <ShowTitle>
          <LinkEl routeId="details" showId='rec47bbcAmGcy06c0' top>
            {/* { get(find(showGroup), 'name') } */}
            Show III
          </LinkEl>
        </ShowTitle>
        <Description
          className="statement">
          <p>MICA GRAD SHOW III was to take place as a combined M.F.A. exhibition, featuring the work of 40 students from 4 M.F.A. programs: Community Arts, Mount Royal School of Art, Photographic and Electronic Media, and Rinehart School of Sculpture.</p>
        </Description>
    </div>
  )
}

ShowDetails.propTypes = {
  // name: PropTypes.string.isRequired,
  location: PropTypes.objectOf(PropTypes.object).isRequired,
  showGroup: PropTypes.objectOf(PropTypes.object).isRequired,
}
ShowDetails.defaultProps = {
  name: 'Show IV',
  showLocation: 'Some Gallery This person was in...',
  showDates: 'X – Y...',
}

export default ShowDetails



// WEBPACK FOOTER //
// ./src/components/ProgramsDetail/ShowInfo.jsx